export class StatusWhatsapp {
  online: boolean;

  public constructor(public carregou: boolean, public pronto: boolean, public conectado: boolean, private numero: string) {
    this.online = this.carregou && this.pronto && this.conectado;
  }
}
